export const DECLUTTER_INITIAL_TIME_INTERVAL = 4;
export const DECLUTTER_MIN_TIME_INTERVAL = 1;
export const DECLUTTER_MAX_TIME_INTERVAL = 120;
export const DECLUTTER_TIME_INTERVAL_STEP = 1;

export const DECLUTTER_FILES_STORE_ID = 'declutterStore';
export const DECLUTTER_SELECTION_INSTANCE_ID = 'declutterStore';
export const DECLUTTER_MAX_FILE_COUNT = 100;
